/* src/app/account/partials/quote-section/quote-section.component.scss */
/*# sourceMappingURL=quote-section.component.css.map */
